import { render, staticRenderFns } from "./VsContainerControls.vue?vue&type=template&id=06210783&lang=pug&"
import script from "./VsContainerControls.vue?vue&type=script&lang=js&"
export * from "./VsContainerControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06210783')) {
      api.createRecord('06210783', component.options)
    } else {
      api.reload('06210783', component.options)
    }
    module.hot.accept("./VsContainerControls.vue?vue&type=template&id=06210783&lang=pug&", function () {
      api.rerender('06210783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsContainerControls.vue"
export default component.exports